import { trackThenNavigate } from "utils/analytics"

const LOGIN_BOX_ID = "login_box"
const TRIGGER_CLASSNAME = "js-login-trigger"
const ERROR_CLASSNAME = "js-login-error"
const HIDDEN_EYE_CLASS = "login__eye-icon--hidden"
// const SUBMIT_CLASSNAME = 'js-login-submit';

function syncPasswordToggle(toggle, input) {
  const visible = input.type === "text"
  const label = visible ? toggle.dataset.labelHide : toggle.dataset.labelShow
  const tooltip = toggle.querySelector(".js-password-toggle-label")
  const eyeHideIcon = toggle.querySelector(".js-eye-hide")
  const eyeShowIcon = toggle.querySelector(".js-eye-show")
  if (label) {
    toggle.setAttribute("aria-label", label)
    if (tooltip) tooltip.textContent = label
  }
  if (eyeHideIcon) eyeHideIcon.classList.toggle(HIDDEN_EYE_CLASS, visible)
  if (eyeShowIcon) eyeShowIcon.classList.toggle(HIDDEN_EYE_CLASS, !visible)
}

function initPasswordToggles(root) {
  const toggles = root.querySelectorAll(".js-password-toggle")
  toggles.forEach((toggle) => {
    const field = toggle.closest(".js-password-field")
    const input = field && field.querySelector("input")
    if (!input) return

    toggle.addEventListener("click", () => {
      input.type = input.type === "password" ? "text" : "password"
      syncPasswordToggle(toggle, input)
    })
  })
}

function formSubmitListener({ errorEl }) {
  // Another tap or Enter during the request, or while the browser leaves for
  // the redirect, would log in again and report another `login`.
  let busy = false
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) busy = false
  })

  return async function listener(event) {
    event.preventDefault()
    if (busy) return
    busy = true
    let navigating = false

    try {
      errorEl.textContent = "" // eslint-disable-line no-param-reassign
      errorEl.style.display = "none" // eslint-disable-line no-param-reassign

      const form = event.target
      const url = form.action
      const response = await fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: new FormData(form),
      })

      if (response.status === 429) {
        errorEl.textContent = "Too many login attempts. Please try again later." // eslint-disable-line no-param-reassign
        errorEl.style.display = "block" // eslint-disable-line no-param-reassign
        return
      }

      const result = await response.json()

      if (result.success) {
        const redirectUrl = new URL(result.redirect, window.location.origin) // eslint-disable-line compat/compat
        if (redirectUrl.origin === window.location.origin) {
          const loginBox = document.getElementById(LOGIN_BOX_ID)
          navigating = true
          trackThenNavigate(
            "login",
            { method: "email", touchpoint: loginBox ? loginBox.dataset.touchpoint : undefined },
            () => {
              window.location.href = redirectUrl.href
            },
          )
        } else {
          throw new Error("Invalid redirect URL")
        }
      } else {
        const [firstError] = result.errors
        if (result.error_html) {
          // Built by the server from translations and a route, never from the input
          errorEl.innerHTML = result.error_html // eslint-disable-line no-param-reassign
        } else {
          errorEl.textContent = firstError // eslint-disable-line no-param-reassign
        }
        errorEl.style.display = "block" // eslint-disable-line no-param-reassign
      }
    } catch (err) {
      // console.error(err);
      errorEl.textContent = "An error occurred. Please try again." // eslint-disable-line no-param-reassign
      errorEl.style.display = "block" // eslint-disable-line no-param-reassign
    } finally {
      if (!navigating) busy = false
    }
  }
}

function init() {
  const loginBox = document.getElementById(LOGIN_BOX_ID)
  initPasswordToggles(loginBox || document)
  if (!loginBox) return

  // Get the first error element (since getElementsByClassName returns a collection)
  const errorEl = loginBox.querySelector(`.${ERROR_CLASSNAME}`)
  const form = loginBox.querySelector("form")

  if (form && errorEl) {
    form.addEventListener("submit", formSubmitListener({ errorEl }))
    errorEl.style.display = "none"
  }
  const buttons = document.querySelectorAll(`.${TRIGGER_CLASSNAME}`)
  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault()
    })
  })
}

export default init
